import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommentEntityTypes } from 'src/app/shared/comments/enums/comment-entity-types.enum';

@Component({
  selector: 'app-comments-list-dialog',
  templateUrl: './comments-list-dialog.component.html',
  styleUrls: ['./comments-list-dialog.component.scss'],
  standalone: false,
})
export class CommentsListDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CommentsListDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      entityId: string;
      entityType: CommentEntityTypes;
      canAddComment: boolean;
      privilege: string;
      adminPrivilege: string;
      showDeleteButton: boolean;
    }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
